import { createSelector } from 'reselect';

const selectcommunitySubscriptions = (state: any) => state.communitySubscriptions;


export const selectcommunitySubscriptionsCurrentItem = createSelector([selectcommunitySubscriptions], (communitySubscriptions) => communitySubscriptions.current);

export const selectcommunitySubscriptionsListItems = createSelector([selectcommunitySubscriptions], (communitySubscriptions) => communitySubscriptions.list);

export const selectcommunitySubscriptionsItemById = (itemId: any) =>
    createSelector(selectcommunitySubscriptionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectcommunitySubscriptionsQueryItems = createSelector([selectcommunitySubscriptions], (communitySubscriptions) => communitySubscriptions.query);

export const selectcommunitySubscriptionsCreatedItem = createSelector([selectcommunitySubscriptions], (communitySubscriptions) => communitySubscriptions.create);

export const selectcommunitySubscriptionsUpdatedItem = createSelector([selectcommunitySubscriptions], (communitySubscriptions) => communitySubscriptions.update);

export const selectcommunitySubscriptionsReadItem = createSelector([selectcommunitySubscriptions], (communitySubscriptions) => communitySubscriptions.read);

export const selectcommunitySubscriptionsDeletedItem = createSelector([selectcommunitySubscriptions], (communitySubscriptions) => communitySubscriptions.delete);

export const selectcommunitySubscriptionsSearchedItems = createSelector([selectcommunitySubscriptions], (communitySubscriptions) => communitySubscriptions.search);

export const selectcommunitySubscriptionsItemsCount = createSelector([selectcommunitySubscriptions], (communitySubscriptions) => communitySubscriptions.count);

export const selectcommunitySubscriptionsItemsFilter = createSelector([selectcommunitySubscriptions], (communitySubscriptions) => communitySubscriptions.filter);